export default __webpack_public_path__ + "static/media/img_kanij.7c764d11.png";